import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    navigation: [
      { label: '首页', to: '/' },
      { label: '恋爱漫画', to: '/category/romance' },
      { label: '奇幻漫画', to: '/category/fantasy' },
      { label: '动作漫画', to: '/category/action' },
      { label: '悬疑漫画', to: '/category/suspense' },
    ],
    about: [
      { label: '关于我们', to: '/about' },
      { label: '品牌介绍', to: '/about#brand' },
      { label: '联系我们', to: '/about#contact' },
      { label: '用户口碑', to: '/about#reviews' },
    ],
    help: [
      { label: '阅读指南', to: '/about#guide' },
      { label: '常见问题', to: '/about#faq' },
      { label: '版权声明', to: '/about#copyright' },
    ],
  };

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="text-2xl font-bold font-heading text-background-50">
              韩漫网
            </Link>
            <p className="mt-4 text-sm text-background-400 leading-relaxed">
              韩漫网提供综合服务，实现韩漫在线观看与漫画免费下拉式阅读，好看韩国漫画全集内容丰富，是您最佳的韩漫阅读平台。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于</h4>
            <ul className="space-y-2.5">
              {footerLinks.about.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">帮助</h4>
            <ul className="space-y-2.5">
              {footerLinks.help.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-background-500">
            <p>&copy; {currentYear} 韩漫网 thingschat.cn 版权所有</p>
            <div className="flex items-center gap-4">
              <Link to="/about#privacy" className="hover:text-background-300 transition-colors whitespace-nowrap">隐私政策</Link>
              <Link to="/about#terms" className="hover:text-background-300 transition-colors whitespace-nowrap">服务条款</Link>
              <Link to="/about#copyright" className="hover:text-background-300 transition-colors whitespace-nowrap">版权声明</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}